// extracted by mini-css-extract-plugin
module.exports = {"establishments":"Metrics_establishments__3BmRp","header":"Metrics_header__2Q6rJ","tableHeader":"Metrics_tableHeader__GcA5E"};